module.exports = __webpack_public_path__ + "img/calendar.7c5849d9.svg";